import React, { forwardRef } from 'react';
import { bool, oneOf, number } from 'prop-types';
import {
  alertTypeStyle,
  tagDefault,
  textOverflow,
  typographyVariant,
} from './config';
import { StyledTypography } from './styles';
import AutoScrollWrapper from './AutoScrollWrapper';
import OverlayWrapper from './OverlayWrapper';

/**
 * Typography Component
 * @typedef {{
 * children: React.ReactNode,
 * as: React.ElementType<any>,
 * type: keyof typeof typographyVariant,
 * alertType: keyof typeof alertTypeStyle
 * size: keyof typeof typographyVariant.body | keyof typeof typographyVariant.stylized,
 * overflow: keyof typeof textOverflow;
 * underline: boolean,
 * italic: boolean,
 * textTransform: 'uppercase' | 'lowercase' | 'capitalize',
 * bold: boolean,
 * clamp: number }
 * & import('../styled-system').ColorProps
 * & import('../styled-system').DisplayProps
 * & import('../styled-system').SpacingProps
 * & import('../styled-system').TypographyProps} TypographyProps
 * @type {React.FC<TypographyProps>}
 * @returns
 */
const Typography = (props) => (
  <AutoScrollWrapper overflow={props.overflow}>
    <OverlayWrapper overflow={props.overflow} text={props.children}>
      <StyledTypography as={tagDefault[props.type]} {...props}>
        {props.children}
      </StyledTypography>
    </OverlayWrapper>
  </AutoScrollWrapper>
);

Typography.defaultProps = {
  type: 'body',
  alertType: 'info',
};

Typography.propTypes = {
  alertType: oneOf(Object.keys(alertTypeStyle)),
  overflow: oneOf(Object.keys(textOverflow)),
  type: oneOf(Object.keys(typographyVariant)),
  size: oneOf(
    Object.keys({ ...typographyVariant.body, ...typographyVariant.stylized }),
  ),
  bold: bool,
  italic: bool,
  underline: bool,
  textTransform: oneOf(['lowercase', 'uppercase', 'capitalize']),
  clamp: number,
};

export default Typography;
